import {Component} from '@angular/core';
import {LanguageService} from '../service/language.service';
import {TranslateService} from '@ngx-translate/core';
import {eventsDetails} from './events';
import {url1, url2, url3, url4, url5} from './eventUrls';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
    selector: 'app-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    animations: [
        trigger('fadeInOut', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('300ms ease-in', style({ opacity: 1 }))
            ]),
            transition(':leave', [
                animate('300ms ease-out', style({ opacity: 0 }))
            ])
        ])
    ],
    standalone: false
})
export class EventsComponent {
  // tslint:disable-next-line:variable-name
  constructor(private _language: LanguageService, private translate: TranslateService) {
    this._language.current_lang.subscribe(lang => {
      if (lang === 0 ) {
        translate.use('ro');
      } else {
        translate.use('en');
      }
    });
  }
  eventNr = 5;
  eventsDetails = eventsDetails;
  isEventDetailsVisible = false;
  event1Urls = url1;
  event2Urls = url2;
  event3Urls = url3;
  event4Urls = url4;
  event5Urls = url5;

  selectedEvent($event: string): void {
    this.eventNr = 0;
    setTimeout(() => {
      this.eventNr = Number($event);
      this.isEventDetailsVisible = false;
    }, 300);
  }
  seeEventDetails(): void {
    this.isEventDetailsVisible = true;
  }
  hideEventDetails(): void {
    this.isEventDetailsVisible = false;
  }
  // tslint:disable-next-line:typedef
  get eventUrls() {
    switch (this.eventNr) {
      case 1: {
        return this.event1Urls;
      }
      case 2: {
        return this.event2Urls;
      }
      case 3: {
        return this.event3Urls;
      }
      case 4: {
        return this.event4Urls;
      }
      case 5: {
        return this.event5Urls;
      }
      default: {
        return [];
      }
    }
  }
  // tslint:disable-next-line:typedef
  get activeEvent() {
    return this.eventsDetails.find(e => e.id === this.eventNr);
  }
}
